export const SIDEBAR_POSITION = {
  LEFT: "left",
  RIGHT: "right",
}

export const SIDEBAR_BEHAVIOR = {
  STICKY: "sticky",
  FIXED: "fixed",
  COMPACT: "compact",
}

// Represents the number of milliseconds in a day
export const MS_IN_DAY = 24 * 60 * 60 * 1000

export const CORRESPONDENCE_TYPES = {
  WELCOME: "WELCOME",
}
